function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }

function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }

function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

import { timeStampNow, Observable, getRelativeTime, ONE_MINUTE, generateUUID, clocksNow, elapsed, createValueHistory, PageExitReason } from '@datadog/browser-core';
import { ActionType } from '../../rawRumEvent.types';
import { trackEventCounts } from '../trackEventCounts';
import { PAGE_ACTIVITY_VALIDATION_DELAY, waitPageActivityEnd } from '../waitPageActivityEnd';
import { getSelectorFromElement } from '../getSelectorFromElement';
import { getNodePrivacyLevel } from '../privacy';
import { NodePrivacyLevel } from '../privacyConstants';
import { createClickChain } from './clickChain';
import { getActionNameFromElement } from './getActionNameFromElement';
import { listenActionEvents } from './listenActionEvents';
import { computeFrustration } from './computeFrustration';
import { CLICK_ACTION_MAX_DURATION, updateInteractionSelector } from './interactionSelectorCache';
export var ACTION_CONTEXT_TIME_OUT_DELAY = 5 * ONE_MINUTE; // arbitrary

export function trackClickActions(lifeCycle, domMutationObservable, windowOpenObservable, configuration) {
  var history = createValueHistory({
    expireDelay: ACTION_CONTEXT_TIME_OUT_DELAY
  });
  var stopObservable = new Observable();
  var currentClickChain;
  lifeCycle.subscribe(10
  /* LifeCycleEventType.SESSION_RENEWED */
  , function () {
    history.reset();
  });
  lifeCycle.subscribe(5
  /* LifeCycleEventType.VIEW_ENDED */
  , stopClickChain);
  lifeCycle.subscribe(11
  /* LifeCycleEventType.PAGE_MAY_EXIT */
  , function (event) {
    if (event.reason === PageExitReason.UNLOADING) {
      stopClickChain();
    }
  });

  var _listenActionEvents = listenActionEvents(configuration, {
    onPointerDown: function onPointerDown(pointerDownEvent) {
      return processPointerDown(configuration, lifeCycle, domMutationObservable, pointerDownEvent, windowOpenObservable);
    },
    onPointerUp: function onPointerUp(_ref, startEvent, getUserActivity) {
      var clickActionBase = _ref.clickActionBase,
          hadActivityOnPointerDown = _ref.hadActivityOnPointerDown;
      startClickAction(configuration, lifeCycle, domMutationObservable, windowOpenObservable, history, stopObservable, appendClickToClickChain, clickActionBase, startEvent, getUserActivity, hadActivityOnPointerDown);
    }
  }),
      stopActionEventsListener = _listenActionEvents.stop;

  var actionContexts = {
    findActionId: function findActionId(startTime) {
      return history.findAll(startTime);
    }
  };
  return {
    stop: function stop() {
      stopClickChain();
      stopObservable.notify();
      stopActionEventsListener();
    },
    actionContexts: actionContexts
  };

  function appendClickToClickChain(click) {
    if (!currentClickChain || !currentClickChain.tryAppend(click)) {
      var rageClick = click.clone();
      currentClickChain = createClickChain(click, function (clicks) {
        finalizeClicks(clicks, rageClick);
      });
    }
  }

  function stopClickChain() {
    if (currentClickChain) {
      currentClickChain.stop();
    }
  }
}

function processPointerDown(configuration, lifeCycle, domMutationObservable, pointerDownEvent, windowOpenObservable) {
  var nodePrivacyLevel;

  if (configuration.enablePrivacyForActionName) {
    nodePrivacyLevel = getNodePrivacyLevel(pointerDownEvent.target, configuration.defaultPrivacyLevel);
  } else {
    nodePrivacyLevel = NodePrivacyLevel.ALLOW;
  }

  if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
    return undefined;
  }

  var clickActionBase = computeClickActionBase(pointerDownEvent, nodePrivacyLevel, configuration);
  var _hadActivityOnPointerDown = false;
  waitPageActivityEnd(lifeCycle, domMutationObservable, windowOpenObservable, configuration, function (pageActivityEndEvent) {
    _hadActivityOnPointerDown = pageActivityEndEvent.hadActivity;
  }, // We don't care about the activity duration, we just want to know whether an activity did happen
  // within the "validation delay" or not. Limit the duration so the callback is called sooner.
  PAGE_ACTIVITY_VALIDATION_DELAY);
  return {
    clickActionBase: clickActionBase,
    hadActivityOnPointerDown: function hadActivityOnPointerDown() {
      return _hadActivityOnPointerDown;
    }
  };
}

function startClickAction(configuration, lifeCycle, domMutationObservable, windowOpenObservable, history, stopObservable, appendClickToClickChain, clickActionBase, startEvent, getUserActivity, hadActivityOnPointerDown) {
  var _a;

  var click = newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent);
  appendClickToClickChain(click);
  var selector = (_a = clickActionBase === null || clickActionBase === void 0 ? void 0 : clickActionBase.target) === null || _a === void 0 ? void 0 : _a.selector;

  if (selector) {
    updateInteractionSelector(startEvent.timeStamp, selector);
  }

  var _waitPageActivityEnd = waitPageActivityEnd(lifeCycle, domMutationObservable, windowOpenObservable, configuration, function (pageActivityEndEvent) {
    if (pageActivityEndEvent.hadActivity && pageActivityEndEvent.end < click.startClocks.timeStamp) {
      // If the clock is looking weird, just discard the click
      click.discard();
    } else {
      if (pageActivityEndEvent.hadActivity) {
        click.stop(pageActivityEndEvent.end);
      } else if (hadActivityOnPointerDown()) {
        click.stop( // using the click start as activity end, so the click will have some activity but its
        // duration will be 0 (as the activity started before the click start)
        click.startClocks.timeStamp);
      } else {
        click.stop();
      }
    }
  }, CLICK_ACTION_MAX_DURATION),
      stopWaitPageActivityEnd = _waitPageActivityEnd.stop;

  var viewEndedSubscription = lifeCycle.subscribe(5
  /* LifeCycleEventType.VIEW_ENDED */
  , function (_ref2) {
    var endClocks = _ref2.endClocks;
    click.stop(endClocks.timeStamp);
  });
  var stopSubscription = stopObservable.subscribe(function () {
    click.stop();
  });
  click.stopObservable.subscribe(function () {
    viewEndedSubscription.unsubscribe();
    stopWaitPageActivityEnd();
    stopSubscription.unsubscribe();
  });
}

function computeClickActionBase(event, nodePrivacyLevel, configuration) {
  var rect = event.target.getBoundingClientRect();
  var selector = getSelectorFromElement(event.target, configuration.actionNameAttribute);

  if (selector) {
    updateInteractionSelector(event.timeStamp, selector);
  }

  var _getActionNameFromEle = getActionNameFromElement(event.target, configuration, nodePrivacyLevel),
      name = _getActionNameFromEle.name,
      nameSource = _getActionNameFromEle.nameSource;

  return {
    type: ActionType.CLICK,
    target: {
      width: Math.round(rect.width),
      height: Math.round(rect.height),
      selector: selector
    },
    position: {
      // Use clientX and Y because for SVG element offsetX and Y are relatives to the <svg> element
      x: Math.round(event.clientX - rect.left),
      y: Math.round(event.clientY - rect.top)
    },
    name: name,
    nameSource: nameSource
  };
}

function newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent) {
  var id = generateUUID();
  var startClocks = clocksNow();
  var historyEntry = history.add(id, startClocks.relative);
  var eventCountsSubscription = trackEventCounts({
    lifeCycle: lifeCycle,
    isChildEvent: function isChildEvent(event) {
      return event.action !== undefined && (Array.isArray(event.action.id) ? event.action.id.includes(id) : event.action.id === id);
    }
  });
  var status = 0
  /* ClickStatus.ONGOING */
  ;
  var activityEndTime;
  var frustrationTypes = [];
  var stopObservable = new Observable();

  function stop(newActivityEndTime) {
    if (status !== 0
    /* ClickStatus.ONGOING */
    ) {
      return;
    }

    activityEndTime = newActivityEndTime;
    status = 1
    /* ClickStatus.STOPPED */
    ;

    if (activityEndTime) {
      historyEntry.close(getRelativeTime(activityEndTime));
    } else {
      historyEntry.remove();
    }

    eventCountsSubscription.stop();
    stopObservable.notify();
  }

  return {
    event: startEvent,
    stop: stop,
    stopObservable: stopObservable,

    get hasError() {
      return eventCountsSubscription.eventCounts.errorCount > 0;
    },

    get hasPageActivity() {
      return activityEndTime !== undefined;
    },

    getUserActivity: getUserActivity,
    addFrustration: function addFrustration(frustrationType) {
      frustrationTypes.push(frustrationType);
    },
    startClocks: startClocks,
    isStopped: function isStopped() {
      return status === 1
      /* ClickStatus.STOPPED */
      || status === 2;
    }
    /* ClickStatus.FINALIZED */
    ,
    clone: function clone() {
      return newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent);
    },
    validate: function validate(domEvents) {
      stop();

      if (status !== 1
      /* ClickStatus.STOPPED */
      ) {
        return;
      }

      var _eventCountsSubscript = eventCountsSubscription.eventCounts,
          resourceCount = _eventCountsSubscript.resourceCount,
          errorCount = _eventCountsSubscript.errorCount,
          longTaskCount = _eventCountsSubscript.longTaskCount;

      var clickAction = _objectSpread({
        duration: activityEndTime && elapsed(startClocks.timeStamp, activityEndTime),
        startClocks: startClocks,
        id: id,
        frustrationTypes: frustrationTypes,
        counts: {
          resourceCount: resourceCount,
          errorCount: errorCount,
          longTaskCount: longTaskCount
        },
        events: domEvents !== null && domEvents !== void 0 ? domEvents : [startEvent],
        event: startEvent
      }, clickActionBase);

      lifeCycle.notify(0
      /* LifeCycleEventType.AUTO_ACTION_COMPLETED */
      , clickAction);
      status = 2
      /* ClickStatus.FINALIZED */
      ;
    },
    discard: function discard() {
      stop();
      status = 2
      /* ClickStatus.FINALIZED */
      ;
    }
  };
}

export function finalizeClicks(clicks, rageClick) {
  var _computeFrustration = computeFrustration(clicks, rageClick),
      isRage = _computeFrustration.isRage;

  if (isRage) {
    clicks.forEach(function (click) {
      return click.discard();
    });
    rageClick.stop(timeStampNow());
    rageClick.validate(clicks.map(function (click) {
      return click.event;
    }));
  } else {
    rageClick.discard();
    clicks.forEach(function (click) {
      return click.validate();
    });
  }
}